module.exports = __webpack_public_path__ + "img/GBM1_NK.d4336b14.png";